module.exports = __webpack_public_path__ + "img/p_normalC@2x.d5e749dd.png";